import { isEditorActive, Text } from '@sitecore-jss/sitecore-jss-react';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import useErrorState from '../../../utils/errors/useErrorState';
import { errorMessages } from '../../../utils/errors/constants';
import { resolve } from '../../../utils/object/pathResolver';

const TitleQuestion = ({ rendering, fields, displayErrors, defaultValue, onError }) => {
  const dispatch = useDispatch();
  const [selectedTitle, setSelectedTitle] = useState('');
  const [otherTitle, setOtherTitle] = useState('');
  const [error, setError] = useErrorState(rendering.uid, fields.name?.value, fields, onError);
  const defaultTitles = fields.titles || [];
  const otherTitles = fields.otherTitles || [];
  const errorClass = error && displayErrors ? ' vds-form__input--invalid' : '';

  const validateTitle = title => {
    if (!title || title === '' || title === fields.otherOption?.value) {
      setError(errorMessages.EMPTY);
      return false;
    }
    setError(null);
    return true;
  };

  const handleTitleUpdate = e => {
    const { value } = e.target;
    setSelectedTitle(value);
    if (validateTitle(value)) {
      const index = fields.reduxDispatchType?.payload?.index;
      const dispatchData = {
        type: fields.reduxDispatchType?.value,
        payload: index >= 0 ? { value, index } : value,
      };
      dispatch(dispatchData);
    }
  };

  const validateOtherTitle = otherTitleValue => {
    if (!otherTitleValue || otherTitleValue === '') {
      setError(errorMessages.EMPTY);
      return false;
    }

    const title = otherTitles.find(
      t => t?.fields?.title?.value?.toLowerCase() === otherTitleValue.toLowerCase()
    );
    if (!title) {
      setError(errorMessages.INVALID);
      return false;
    }

    setError(null);
    return true;
  };

  const handleOtherUpdate = e => {
    const { value } = e.target;
    setOtherTitle(value);

    if (validateOtherTitle(value)) {
      const title = otherTitles.find(
        t => t?.fields?.title?.value?.toLowerCase() === value.toLowerCase()
      );
      if (title) {
        const index = fields.reduxDispatchType?.payload?.index;
        const dispatchData = {
          type: fields.reduxDispatchType?.value,
          payload: index >= 0 ? { value, index } : value,
        };
        dispatch(dispatchData);
      }
    }
  };

  const renderOtherTitles = () => {
    if (selectedTitle !== fields.otherOption?.value) {
      return null;
    }
    return (
      <div className="vds-form__group vds-form__group--limited-width">
        <Text
          tag="label"
          className="vds-form__label"
          htmlFor="other-title"
          field={fields.otherTitleLabel}
        />
        {isEditorActive() && <span>Values can only be edited in Content Editor</span>}
        <input
          id="other-title"
          type="text"
          className={`vds-form__input${errorClass}`}
          name={`${fields.name?.value}-other`}
          data-testid={`${fields.testid?.value}-other`}
          value={otherTitle}
          onChange={handleOtherUpdate}
          required={fields.required?.value}
        />
      </div>
    );
  };

  useEffect(() => {
    if (fields.required?.value && !selectedTitle && !otherTitle && !defaultValue) {
      setError(errorMessages.EMPTY);
    } else {
      if (defaultTitles.find(t => t.fields.title.value === defaultValue)) {
        setSelectedTitle(defaultValue);
      } else if (otherTitles.find(t => t.fields.title.value === defaultValue)) {
        setSelectedTitle(fields.otherOption.value);
        setOtherTitle(defaultValue);
      } else {
        // Do nothing
      }
    }
    return () => {
      setError(null);
    };
  }, []);

  return (
    <>
      <div className="vds-form__group vds-form-group--limited-width" name={fields.name?.value}>
        <Text tag="label" className="vds-form__label show" field={fields.titleLabel} />
        {isEditorActive() && <span>These values can only be edited in Content Editor.</span>}
        <select
          className={`vds-form__input vds-form__input--select${errorClass}`}
          name={`${fields.name?.value}-title`}
          data-testid={`${fields.testid?.value}`}
          id="title-question"
          value={selectedTitle}
          onChange={handleTitleUpdate}
          required={fields.required?.value}
        >
          {fields.placeholder?.value && <option value="">{fields.placeholder.value}</option>}
          {defaultTitles &&
            defaultTitles.map((o, i) => (
              <option key={i} value={o.fields.title.value}>
                {o.fields.title.value}
              </option>
            ))}
        </select>
      </div>
      {renderOtherTitles()}
      {displayErrors && fields.inlineError?.value && error && (
        <div className="vds-form__group">
          <div className="vds-form__validation-message vds-form__validation-message--invalid">
            <span className="vds-form__validation-text">{error.message}</span>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state, props) => {
  const reduxValuePath = props.fields.reduxValuePath?.value;
  let defaultValue;
  if (reduxValuePath) {
    defaultValue = resolve(reduxValuePath, state);
  }
  return {
    ...props,
    defaultValue,
    displayErrors: props.displayErrors || state.appState.displayErrors,
  };
};
export default connect(mapStateToProps)(TitleQuestion);
